export const ROLE_ACTIONS_TYPE = {
  GET_ROLE_ACTION_SUCCESS: 'GET_ROLE_ACTION_SUCCESS',
};
